import type { PropsWithChildren } from "react";

import Button from "~/components/buttons/Button/Button";
import type { CardVariantProps } from "~/components/Card/cardVariants.ts";
import CardContent from "~/components/Card/components/CardContent";
import CardHeader from "~/components/Card/components/CardHeader";
import CardTitle from "~/components/Card/components/CardTitle";
import CardWrapper from "~/components/Card/components/CardWrapper";

type HeaderButtonActionProps =
	| { onHeaderButtonClick?: () => void; headerButtonTo?: never }
	| { onHeaderButtonClick?: never; headerButtonTo?: string };

type CardProps = PropsWithChildren & CardVariantProps & HeaderButtonActionProps & {
	title?: string;
	headerButtonText?: string;
};

const Card: React.FunctionComponent<CardProps> = ({
		title,
		headerButtonText,
		onHeaderButtonClick,
		headerButtonTo,
		children,
		...variantProps
	}) => {
		if (onHeaderButtonClick && headerButtonTo) {
			throw new Error("Card: provide either onHeaderButtonClick or headerButtonTo, not both.");
		}

		const hasHeaderButtonAction = !!onHeaderButtonClick || !!headerButtonTo;

		return <CardWrapper hasTitle={!!title} {...variantProps}>
			{title && <CardHeader hasTitle={!!title} {...variantProps}>
				<div>
					<CardTitle>{title}</CardTitle>
				</div>

				{headerButtonText && hasHeaderButtonAction && <Button size="auto"
																	  theme="plain"
																	  className="px-2 py-1 text-xs"
																	  onClick={onHeaderButtonClick}
																	  to={headerButtonTo}>{headerButtonText}</Button>}
			</CardHeader>}
			<CardContent hasTitle={!!title} {...variantProps}>{children}</CardContent>
		</CardWrapper>;
	}
;

export default Card;